export enum PaymentMethodsRoutes {
  root = 'payment-methods',
  main = '',
  personal = 'personal-payment-methods',
}
